import { Component } from '@angular/core';
import { first, map } from 'rxjs/operators';
import { User } from '../models';
import { Inotification } from '../models/notification';
import { UserService, AuthenticationService, DashboardService, SpinnerService, DealerService } from '../services';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TopLayoutComponent } from '../layouts/top-layout.component';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';


@Component({
    templateUrl: 'active-dealers-dashboard.component.html'
    , styleUrls: ['styles.scss']
})
export class ActiveDealersDashboardComponent {
    users: User[] = [];
    currentUser: User;
    dealerEnrollmentsCount: any;
    subscriptionCount: any;
    mydata: any[] = [];

    // myData : any [
    //     ['London', 8136000],
    //     ['New York', 8538000],
    //     ['Paris', 2244000],
    //     ['Berlin', 3470000],
    //     ['Kairo', 19500000],
    //     ...
    //   ];
    dealerEnrollmentsCountColumnDefs = [
        { headerName: 'Source', field: 'SourceName' },
        { headerName: 'Count', field: 'DealersCount' }
    ];
    subscriptionCountColumnDefs = [
        { headerName: 'Client Name', field: 'ClientName' },
        { headerName: 'Count', field: 'DealersCount' }
    ];
    totalNoOfIssuesCountColumnDefs = [
        { headerName: 'Status', field: 'Status' },
        { headerName: 'Count', field: 'Count' }
    ];
    OemColors = [
        { oemCode: 'BMW', color: '#1a0dab' },
        { oemCode: 'DD', color: '#309dbe' },
        { oemCode: 'DD-BMW', color: '#1a0dab' },
        { oemCode: 'FC', color: '#e4e1e8' },
        { oemCode: 'FCA', color: '#7f7c6e' },
        { oemCode: 'GM', color: '#6a5b56' },
        { oemCode: 'JLR', color: '#3e78ba' },
        { oemCode: 'KIA', color: '#bb1022' },      
        { oemCode: 'MAS', color: '#e0ac00' },
        { oemCode: 'MINI', color: '#751e0d' },
        { oemCode: 'MTB', color: '#0b5c94' },
        { oemCode: 'MTR', color: '#f60f14' },   
        { oemCode: 'PWS', color: '#94e9f7' },
        { oemCode: 'RRY', color: '#107f1c' }
    ];
    subMsg: any = "";
    totalDataProcessed: any;
    rowGroupMetadata: {};
    totalNoOfIssues: any;
    dealerCountByOemData: any[] = [];
    chartColumns: any[] = [];
    ChartTitle: string;
    OemChartOptions: any;
    dealerCountBySourceData: any[] = [];
    sourceChartColumns: any[] = [];
    SourceChartOptions: any;
    pageTitle: string;
    clientChartColumns: any[] = [];
    clientChartOptions: any;
    dealerCountByClientData: any[] = [];
    totalDealerCount: any;
    downloadFileName: string;
    masterdealerCountByClientData: any;
    masterdealerCountBySourceData: any;
    masterdealerCountByOemData: any;
    excelDealers: any;
    constructor(private userService: UserService,
        private dealerService: DealerService,
        private dasboardService: DashboardService,
        private router: Router,
        private spinnerService: SpinnerService,
        private authenticationService: AuthenticationService,
        private http: HttpClient) { }

    ngOnInit() {
        this.pageTitle = 'Active Dealers'
        this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
        this.spinnerService.start();
        this.TotalDealerCount();
        this.dealerCountByOemGet();
        this.dealerCountBySourceGet();
        this.dealerCountByClientGet();
    }
    dealerCountByOemGet() {
        this.spinnerService.start();
        this.chartColumns = ['OemCode', 'DealerCount', { role: 'tooltip' }, { role: 'style' }, { role: 'annotation' }];
        this.OemChartOptions = {
           // title: "Dealers By OEM",
            width: 1300,
            height: 450,
            legend: { position: 'none' },
            explorer: { axis: 'horizontal' },
            bar: {groupWidth: "80%"},
            chartArea:{width:'70%',height:'90%'}
        }
        this.dasboardService.dealerCountByOemGet().pipe(first()).subscribe(data => {
            this.masterdealerCountByOemData = data;
            this.dealerCountByOemData = [];
            var t, color;
            data.forEach(ee => {
                t = this.OemColors.filter(e => (e.oemCode == ee.OemCode))
                if (t == undefined || t == '') {
                    color = '#1a0db3';
                } else {
                    color = t[0].color;
                }
                this.dealerCountByOemData.push([ee.OemName, ee.DealerCount, ee.OemName + ' - ' + ee.DealerCount, color, ee.DealerCount]);
                t = "";
            });
            console.log(data);
            // this.spinnerService.stop();
        });
    }
    dealerCountBySourceGet() {
        this.spinnerService.start();
        this.sourceChartColumns = ['Source', 'DealerCount', { role: 'tooltip' }, { role: 'style' }, { role: 'annotation' }];
        this.SourceChartOptions = {
            //title: "Dealers by DMS Source",
            // width: 1300,
            // height:550,
            // legend: { position: 'none' },       
            width: 1300,
            height: 450,
            legend: { position: 'none' },
            explorer: { axis: 'horizontal' },
            bar: {groupWidth: "90%"},
            chartArea:{width:'75%',height:'85%'}     
        }
        this.dasboardService.getDealersCountBySource().pipe(first()).subscribe(data => {
            this.masterdealerCountBySourceData = data;
            this.dealerCountBySourceData = [];
            data.forEach(ee => {
                this.dealerCountBySourceData.push([ee.SourceName, ee.DealersCount, ee.SourceName + ' - ' + ee.DealersCount, '', parseInt(ee.DealersCount)]);
            });

        });
    }
    dealerCountByClientGet() {
        this.spinnerService.start();
        this.clientChartColumns = ['Client', 'DealerCount', { role: 'tooltip' }, { role: 'style' }, { role: 'annotation' }];
        this.clientChartOptions = {
            //title: "Dealers By Client",
            width: 800,
            height: 200,
            legend: { position: 'none' },
            chartArea:{width:'75%',height:'75%'}   
        }
        this.dasboardService.getDealersCountByClient().pipe(first()).subscribe(data => {
            this.masterdealerCountByClientData = data;
            this.dealerCountByClientData = [];
            data.forEach(ee => {
                this.dealerCountByClientData.push([ee.ClientName, ee.DealersCount, ee.ClientName + ' - ' + ee.DealersCount, '', parseInt(ee.DealersCount)]);
            });
            this.spinnerService.stop();
        });
    }
    TotalDealerCount() {
        this.dasboardService.totalDealerCount().pipe(first()).subscribe(data => {
            this.totalDealerCount = data[0].TotalDealersCount;
        });
    }
    downloadexcel(downloadExcelFlag) {
        let data, filename;
        if (downloadExcelFlag == 'clientdata') {
            data = this.masterdealerCountByClientData;
            filename = 'dealer_count_by_client';
        } else if (downloadExcelFlag == 'oemdata') {
            data = this.masterdealerCountByOemData
            filename = 'dealer_count_by_oem'
        } else if (downloadExcelFlag == 'sourcedata') {
            data = this.masterdealerCountBySourceData
            filename = 'dealer_count_by_source'
        }
        this.exportExcel(data, filename);
        this.spinnerService.start();
    }
    exportExcel(data, filename) {
        import("xlsx").then(xlsx => {
            const worksheet = xlsx.utils.json_to_sheet(data);
            const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
            const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
            this.saveAsExcelFile(excelBuffer, filename);
        });
    }
    saveAsExcelFile(buffer: any, fileName: string): void {
        import("file-saver").then(FileSaver => {
            let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
            let EXCEL_EXTENSION = '.xlsx';
            const data: Blob = new Blob([buffer], {
                type: EXCEL_TYPE
            });

            FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
        });
        this.spinnerService.stop();
    }
    downloadDealers() {
        this.spinnerService.start();
        this.dealerService.getDealers('', '', 'All', 0, 'desc', 'updateddt', 10, 1, 1).pipe(first()).subscribe(dealers => {
            this.excelDealers = dealers;
            this.excelDealers.forEach(function (x) {
                x.OEMCode = x.OemCode;
                delete x.CreatedBy;
                delete x.ListDealerMapping;
                delete x.ListLastServiceDates;
                delete x.DealerId;
                delete x.SearchText;
                delete x.UpdatedBy;
                delete x.DpsClientId;
                delete x.OcClientId;
                delete x.AlClientId;
                delete x.OemCode;
                delete x.PageSize;
                delete x.DealerSource;
                delete x.PageNo;
                delete x.Zip;
                delete x.SalesforceID;
                delete x.ListLastSaleDates;
                delete x.DeleteComments;
                delete x.DataSourceId;
                delete x.Mode;
                delete x.SortValue;
                delete x.OpcodeProcessedDate;
                delete x.DealerMappingId;
                delete x.DealerGuid;
                delete x.ParentDealerId;
                delete x.TimeZone;
                delete x.IsOpcodeRequired;
                delete x.DealerCount;
                delete x.EffectiveDate;
                delete x.DealerMappingDeleteFlag;
                delete x.TotalRecordCount;
            });
            this.exportExcel(this.excelDealers, "ADMT_Active_Dealers");

            this.spinnerService.stop();
        });
    }
}









